import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { VideoUploadService } from "@vkontakte/video-upload-sdk";

export default function VkVideoUploader({ urlForGetUploadLink, apiData, setApiData, btnRef, prefix = "main" }) {
    const { t } = useTranslation();
    const { setToastMessage, apiIsLoading } = useAppContext();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState();
    const [uploadUrl, setUploadUrl] = useState();
    const [videoId, setVideoId] = useState();
    const [progress, setProgress] = useState(0);
    const { api_post } = useRequest();

    const progressInstance = (
        <ProgressBar variant="success" animated now={progress} label={`${progress.toFixed(2)}%`} />
    );

    const fetchUploadUrl = () => {
        api_post("fetch_upload_url", urlForGetUploadLink, {
            then: (resp) => {
                if (resp?.video_id && resp?.link) {
                    setUploadUrl(resp.link);
                    setVideoId(resp.video_id);
                } else {
                    setToastMessage(t("Не удалось получить ссылку для загрузки видео"));
                }
            },
        });
    };

    const resetData = () => {
        setIsLoading(false);
        setUploadUrl(undefined);
        setSelectedFile(undefined);
        setProgress(0);
    };

    const uploadVideoHandle = () => {
        // TODO: надо узнать, как получить url сразу с https с бэка
        const url = uploadUrl?.replace("http://", "https://");

        setIsLoading(true);

        VideoUploadService.createUploadSession(url, selectedFile)
            .onProgress((progressValue) => setProgress(progressValue))
            .onFail(() => setToastMessage(t("Не удалось загрузить видео")))
            .onSuccess(() => {
                const newData = { ...apiData };
                newData.forms_data[prefix].data.vkvideo_id = videoId;
                delete newData.forms_data[prefix].data.vkvideo_file;
                setApiData(newData);
            })
            .upload()
            .then(() => btnRef.current.click())
            .finally(() => resetData());
    };

    const cancelUploadHandle = () => {
        VideoUploadService.stopAllUploadSessions(true).then(() => {
            resetData();
            const newData = { ...apiData };
            delete newData.forms_data[prefix].data.vkvideo_file;

            setApiData(newData);
        });
    };

    useEffect(() => {
        if (selectedFile && !uploadUrl) {
            fetchUploadUrl();
        }
    }, [selectedFile, uploadUrl]);

    useEffect(() => {
        if (apiData.forms_data) {
            const file = apiData.forms_data[prefix]?.data?.vkvideo_file;
            if (file) {
                setSelectedFile(file[0]);
            }
        }
    }, [apiData]);

    useEffect(() => {
        // TODO: нужно ли подчищать недогруженные сессии?
        //const list = VideoUploadService.getStoredUploadSessionDataList();
        //console.log(list);

        VideoUploadService.clearExpiredUploadSessionsData();
    }, []);

    return (
        <FormFieldGroup>
            {apiIsLoading === "fetch_upload_url" && (
                <div className="d-flex align-items-center mt-2">
                    <Spinner as="span" animation="border" size="sm" className="mr-2" />
                    <span className="ml-2">{t("Подготавливаем ссылку для загрузки. Подождите...")}</span>
                </div>
            )}
            {selectedFile && uploadUrl && (
                <>
                    {progressInstance}
                    <div className="mt-2">
                        {isLoading ? (
                            <DevForm.Button className="btn btn-light" name="canel_upload" onClick={cancelUploadHandle}>
                                {t("Отменить")}
                            </DevForm.Button>
                        ) : (
                            <DevForm.Button name="upload_video" onClick={uploadVideoHandle}>
                                {t("Загрузить")}
                            </DevForm.Button>
                        )}
                    </div>
                </>
            )}
        </FormFieldGroup>
    );
}
